var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verification-container"},[_c('div',{staticClass:"send-btn",class:{ disabled: _vm.isCountingDown },on:{"click":_vm.sendCode}},[_vm._v(" "+_vm._s(_vm.isCountingDown ? `Resend(${_vm.countdown}s)` : 'Get Code')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }